export default {
  // 侧边导航栏
  navigation: {
    home: '首頁',
    gameCenter: '遊戲中心',
    rechargeCenter: '充值中心',
    imChat: 'IM聊天',
    consult: '星遇咨讯',
  },

  // 首頁
  home: {
    platformFeatures: '平台特色',
    quickActionsName: '快速操作',
    footerText: '讓直播更簡單，讓互動更有趣',
    features: {
      gameCenter: {
        title: '遊戲中心',
        description: '豐富的遊戲資源，支持多平台直播',
      },
      imChat: {
        title: '即時通訊',
        description: '實時聊天互動，提升觀眾體驗',
      },
      dataAnalysis: {
        title: '數據分析',
        description: '詳細的數據統計，助力直播優化',
      },
      efficientStable: {
        title: '高效穩定',
        description: '流暢的直播體驗，穩定的服務保障',
      },
    },
    stats: {
      activeUsers: '活躍用戶',
      gameResources: '遊戲資源',
      serviceAvailability: '服務可用性',
      technicalSupport: '技術支持',
    },
    quickActions: {
      gameCenter: '遊戲中心',
      imChat: 'IM聊天',
      consult: '星遇諮詢',
    },
  },

  // 游戏中心
  gameCenter: {
    language: '繁體中文',
    balance: '餘額',
    hotGames: '熱播遊戲',
    download: '下載',
    update: '更新',
    startTikTok: '開播',
    startBigo: '開播',
    document: '文檔',
    currentGame: '當前開播遊戲：',
    currentStatus: '當前開播狀態：',
    recharge: '充值',
    restart: '重啟工具及遊戲',
    closeLive: '關播',
    downloadProgress: '下載進度：',
    decompProgress: '解壓進度：',
    waitDecomp: '等待解壓',
    fixBug: '修復bug（Fix bug）',
    clickUpdate: '點擊更新(Click update)',
    downloading: '下載中，請耐心等候~（Please wait patiently while downloading ~）',
    pay: '支付中...',
    xzf: '需要支付',
    zs: '鑽石',
    dest: '彈幕遊戲 防封插件',
    getff: '解鎖防封權限',
    ffbtun: '防機審開播',
    qrkb: '確認开播',
    tkl: '您準備好啟動防機審開播了嗎？',
    qd: '確認',
    qx: '取消',
  },

  // IM聊天
  imChat: {
    search: '搜尋',
    searchNoResult: '暫未搜尋到該用戶',
    tryOtherKeywords: '請嘗試其他搜尋關鍵詞',
    noConversations: '暫無聊天記錄',
    startChatting: '搜尋用戶開始聊天吧',
    loadingConversations: '加載會話列表中...',
    connecting: '正在連接聊天服務器...',
    connectionFailed: '⚠️連接失敗，聊天功能暫不可用',
    checkNetwork: '請檢查網絡連接或聯繫客服',
    selectUser: '請選擇一個用戶開始聊天',
    sending: '發送中...',
    sendMessage: '發送',
    enterMessage: '請輸入消息...',
    noMessages: '暫無消息',
    officialUser: '星遇互遊',
    welcomeChat: '歡迎使用聊天功能',
    selectConversationHint: '請從左側選擇一個會話開始聊天',
    inputDisabledDisconnected: '連線已斷開，聊天暫不可用，其他功能正常，恢復聊天功能請重新登入再試',
    inputDisabledOfficialNotification: '官方通知為單向通知，您只能接收消息',
    RecentSessions: '最近會話',
    RecommendedChat: '全球好友',
    Online: '線上',
    Offline: '離線',
  },

  // 咨询
  StalConsult: {
    search2: '搜索',
    all: '全部',
    Payment: '支付',
    ViewFullContent: '查看全部内容',
    UnlockFullContent: '解锁全部内容',
    NeedToPay: '需要支付',
    diamond: '鑽石',
    CurrentBalance: '当前余额',
    Cancel: '取消',
    PayNow: '立即支付',
    InsufficientBalance: '余额不足',
    loading: '加载中...',
    NoMoreContent: '没有更多内容了',
    return: '返回',
    fd: '放大查看',
  },

  // 通用提示
  common: {
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    loading: '加載中...',
    success: '成功',
    failed: '失敗',
    error: '錯誤',
    warning: '警告',
    info: '信息',
  },
}
